function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 15a1.5 1.5 0 0 1 0-3h12a1.5 1.5 0 0 1 0 3h-12zm0 6a1.5 1.5 0 0 1 0-3h6a1.5 1.5 0 0 1 0 3h-6zm12 12a1.5 1.5 0 0 1 0-3h6a1.5 1.5 0 0 1 0 3h-6zm1.5-4.5a1.5 1.5 0 0 1 3 0v6a1.5 1.5 0 0 1-3 0v-6zM30.5 39a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0 3C24.701 42 20 37.299 20 31.5S24.701 21 30.5 21 41 25.701 41 31.5 36.299 42 30.5 42zm4.481-19.28h-3V10.5a1.5 1.5 0 0 0-1.5-1.5H12.5a1.5 1.5 0 0 0-1.5 1.5v23.994a1.5 1.5 0 0 0 1.5 1.5h10.513v3H12.5a4.5 4.5 0 0 1-4.5-4.5V10.5A4.5 4.5 0 0 1 12.5 6h17.981a4.5 4.5 0 0 1 4.5 4.5v12.22z"
});

var Svg003Created = function Svg003Created(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default Svg003Created;


//////////////////
// WEBPACK FOOTER
// ./src/icons/order-status/003-created.svg
// module id = 221
// module chunks = 0 1